import React from 'react'

export const READY = "초대 보내기"
export const CAN_SUBMIT = "초대 보내기"
export const DOING = <span className="ico_blog">초대중</span>
export const DONE = [
	'초대 완료',
	<span key="1" className="ico_blog" />
]
